<!-- 注销登记 -->
<template>
  <div>
    <div class="login">
      <div class="topImgDiv">
        <img src="../assets/image/btn_beijingkapian_nor.png" alt="顶部" class="topImg" />
        <div class="logoImgDiv">
          <img src="../assets/image/btn_jiao.png" alt="logo" class="logoImg" />
        </div>
      </div>
      <!--             <div class="schoolName">东北大学</div>
 -->
      <div class="schoolName">沈阳工程学院</div>
      <div class="name">校友服务平台</div>
      <div class="loginCard">
        <el-form :rules="rules" :model="postForm" ref="form" class="demo-ruleForm">
        <!--   <div class="nameInput">
            <el-form-item prop="name">
              <el-input placeholder="请输入姓名" v-model="postForm.name">
                <i slot="prefix" class="el-icon-bank-card"></i>
              </el-input>
            </el-form-item>
          </div> -->
          <div class="phone">
            <el-form-item prop="phone">
              <el-input placeholder="请输入手机号码" v-model="postForm.phone">
                <i slot="prefix" class="el-icon-mobile-phone"></i>
              </el-input>
            </el-form-item>
          </div>
          <div class="code">
            <el-form-item prop="phoneCode">
              <el-input placeholder="请输入验证码" v-model="postForm.phoneCode">
                <i slot="prefix" class="el-icon-unlock"></i>
                <button slot="append" v-show="show" class="codeBtn" @click.prevent="getPhoneCode">
                  获取验证码
                </button>
                <button slot="append" v-show="!show" class="disableCodeBtn">
                  {{ count }} 秒后重试
                </button>
              </el-input>
            </el-form-item>
          </div>
        </el-form>
        <div class="loginBtnDiv">
          <button class="loginBtn" @click="login">注册</button>
        </div>
      </div>
      <!-- <div class="copyright">技术 • 运营</div>
      <div class="copyrightCompany">辽宁校友汇数据科技有限公司</div> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      postForm: {
        name: "",
        phone: "",
        phoneCode: "",
      },
      openid: "",
      code: "",
      show: true,
      count: "",
      imgUrl: '',
      timer: null,
      rules: {
        /* name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 1, max: 8, message: "长度在 1 到 8 个字符", trigger: "blur" },
        ], */
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        phoneCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    // window.localStorage.setItem("openid", "");
    if (
      window.localStorage.getItem("writeOffOpenid") == "" ||
      window.localStorage.getItem("writeOffOpenid") == null
    ) {
      this.getCode();
    } else {
      this.getUserData();
    }
  },
  methods: {
    getCode() {
      // 非静默授权，第一次有弹框
      var local = window.location.href; // 获取页面url
      //var local = "http://xyhall.alumni-resource.com/index.html"; // 获取页面url
           // TODO--START
      var appid = "wx56458d4baeea3d63";  // 校友汇公众号
      // var appid = "wxae254986265f7048";
     // TODO--END
      this.code = this.getUrlCode().code; // 截取code
      if (this.code == null || this.code === "") {
        // 如果没有code，则去请求
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
          local
        )}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
      } else {
        this.getOpenIdApi();
      }
    },
    getUrlCode() {
      // 截取url中的code方法
      var url = location.search;
      this.winUrl = url;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      return theRequest;
    },
    async getOpenIdApi() {
      const result = await this.$http.get("/writeoffUser/getUserInfo", {
        params: { code: this.code },
      });
      this.openid = result.data.openid;
      window.localStorage.setItem("writeOffOpenid", this.openid);
      this.imgUrl = result.data.headimgurl;
      window.localStorage.setItem("imgUrl", this.imgUrl);
      this.postForm.name = result.data.nickname
      window.localStorage.setItem("writeOffName", result.data.nickname);
      this.getUserData();
    },
    async getUserData() {
      const result = await this.$http.get("/writeoffUser/isWriteoffUser", {
        params: { openid: window.localStorage.getItem("writeOffOpenid") }
      });
      // 判断是否是新用户
      if (result.data.未注册 !== 0) {
        return this.$router.push("/writeOffRegisterSucc");
      }
    },
    async getPhoneCode() {
      if (this.postForm.phone == "") {
        this.$toast("请输入手机号");
      } else {
        const result = await this.$http({
          url: "/login/makeSmsCode",
          method: "POST",
          headers: { "content-type": "application/x-www-form-urlencoded" },
          data: this.$qs.stringify({ phone: this.postForm.phone }),
        });
        this.settime();
        if (result.data.code == "101") {
          this.$toast("发送成功");
        } else {
          this.$toast(result.data.msg);
        }
      }
    },
    settime() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    async login() {
      this.$refs.form.validate(async (valid) => {
        // 请求api之前的一个前端验证
        if (!valid) {
          return;
        }
        const result = await this.$http({
          url: "/writeoffUser/insertWriteoffUser?" + 'phone=' + this.postForm.phone + '&code=' + this.postForm.phoneCode + '&img=' + encodeURI(this.imgUrl) + '&name=' + encodeURI(this.postForm.name) + '&openid=' + window.localStorage.getItem("writeOffOpenid"),
          method: "POST",
          //headers: { "content-type": "application/x-www-form-urlencoded" },
          /* data: {
            phone: this.postForm.phone,
            code: this.postForm.phoneCode,
            wxCode: this.code,
          }, */
        });
        if (result.data.openid !== null ) {
          this.$toast("注册成功");
          return this.$router.push("/writeOffRegisterSucc");
        } else {
          this.$toast(result.data.msg);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.login::-webkit-scrollbar {
  display: none;
}

.login {
  position: relative;
  min-height: 100vh;

  .topImgDiv {
    position: relative;
    width: 100%;
    margin-bottom: 15%;

    .topImg {
      width: 100%;
    }

    .logoImgDiv {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateX(-50%);
      width: 33%;

      .logoImg {
        width: 100%;
      }
    }
  }

  .schoolName,
  .name {
    margin-bottom: 10px;
    font-size: 1.3rem;
    font-weight: bold;
    color: #000000;
    text-align: center;
  }

  .loginCard {
    position: relative;
    left: 5%;
    width: 90%;
    margin-top: 20px;
    background: #ffffff;
    box-shadow: 2px 3px 5px 1px rgba(140, 158, 206, 0.84);
    border-radius: 15px;

    .nameInput,
    .phone,
    .code {
      position: relative;
      left: 5%;
      width: 90%;

      /deep/.el-input__inner {
        border-top-width: 0;
        border-left-width: 0;
        border-right-width: 0;
        color: #666666;
        margin-top: 20px;
      }

      .codeBtn {
        background-color: white;
        border: 1px solid #00706E;
        padding: 4px 8px;
        border-radius: 20px;
      }

      .disableCodeBtn {
        background-color: white;
        border: 1px solid gray;
        color: gray;
        padding: 4px 8px;
        border-radius: 20px;
      }
    }

    .loginBtnDiv {
      position: relative;
      left: 5%;
      width: 90%;
      margin-top: 50px;

      .loginBtn {
        margin-bottom: 30px;
        width: 100%;
        font-size: 1.1rem;
        background: linear-gradient(270deg, #00706E, #00706E);
        border-radius: 45px;
        border: none;
        padding: 10px 0;
        color: white;
      }
    }
  }
}

/deep/.el-input-group__append {
  padding: 0;
  background-color: white;
  border-top-width: 0;
  border-left-width: 0;
  border-right-width: 0;
  color: #00706E;
}

/deep/.el-input__prefix {
  top: 45%;
}

/deep/.el-form-item__content {
  line-height: 0;
}

/deep/ .el-form-item {
  margin-bottom: 0;
}

/deep/.el-icon-mobile-phone,
.el-icon-bank-card,
.el-icon-unlock {
  font-size: 20px;
}

.copyright {
  position: absolute;
  bottom: 14%;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 400;
  color: #999999;
}

.copyrightCompany {
  position: absolute;
  bottom: 10%;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 400;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/components/WriteOffRegister.vue